"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultLastMonth = defaultLastMonth;
exports.formatAccount = formatAccount;
exports.formatBillMonth = formatBillMonth;
exports.formatKwh = formatKwh;
exports.formatMoney = formatMoney;
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.replace");
function formatMoney(val) {
  var n = parseFloat(val);
  if (isNaN(n)) return '¥0.00';
  return '¥' + n.toFixed(2);
}
function formatKwh(val) {
  var n = parseFloat(val);
  if (isNaN(n)) return '0';
  return n.toFixed(4).replace(/\.?0+$/, '') || '0';
}
function formatAccount(aid, name) {
  var n = (name || '').trim();
  var id = parseInt(aid, 10);
  if (!n && (!id || id <= 0)) return '-';
  if (id > 0) return "[".concat(id, "]").concat(n || '-');
  return n || '-';
}
function defaultLastMonth() {
  var d = new Date();
  d.setMonth(d.getMonth() - 1);
  return formatBillMonth(d);
}
function formatBillMonth(val) {
  if (!val) return '';
  if (val instanceof Date && !isNaN(val.getTime())) {
    var y = val.getFullYear();
    var m = String(val.getMonth() + 1).padStart(2, '0');
    return "".concat(y, "-").concat(m);
  }
  var text = String(val).trim();
  var matched = text.match(/^(\d{4})-(\d{1,2})/);
  if (!matched) return text;
  return "".concat(matched[1], "-").concat(String(parseInt(matched[2], 10)).padStart(2, '0'));
}